import type { Input } from '~/components/ui/input'
import { InputGroup, InputGroupInput } from '~/components/ui/input-group'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type TextFieldGroupProps = React.ComponentProps<typeof Input> &
  Omit<FieldProps, 'children' | 'error'> & {
    inputClassName?: string
  }

export function TextFieldGroup({
  label,
  id,
  optional,
  className,
  children,
  inputClassName,
  ...props
}: TextFieldGroupProps) {
  const field = useFieldContext<string>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
    >
      <InputGroup className="shadow-none">
        <InputGroupInput
          {...props}
          id={field.name}
          name={field.name}
          onBlur={field.handleBlur}
          onChange={(e) => {
            field.handleChange(e.target.value)
          }}
          aria-invalid={errorMessage !== undefined}
          value={field.state.value}
          className={inputClassName}
        />
        {children}
      </InputGroup>
    </Field>
  )
}
